import { lazy } from 'react';

export interface PersonaRoute {
  path: string;
  banner: string;
  component: React.ComponentType;
  /** Legacy path that should redirect to this route */
  legacyPath?: string;
}

const InsightsDashboard = lazy(() => import('./pages/InsightsDashboard'));
const SelfCareDashboard = lazy(() => import('./pages/SelfCareDashboard'));

// NOTE: The `admin` persona (AdminDashboard) is intentionally NOT registered
// here. The /admin section is unmaintained and hidden for now (EL-502); all
// /admin/* paths are redirected to /insights in App.tsx. The AdminDashboard
// component and its sub-pages are kept on disk so the section can be revived
// by re-adding an entry here and removing the redirect.
const routes: PersonaRoute[] = [
  {
    path: 'insights',
    banner: 'Insights',
    component: InsightsDashboard,
    legacyPath: 'assist',
  },
  {
    path: 'self-care',
    banner: 'Self-Care',
    component: SelfCareDashboard,
  },
];

export default routes;
